module.exports = "<!--first display position, render initial route here-->\n<div id=\"app\" [class.app-boxed-page]=\"app.layout.isBoxedPage\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main